// webui/src/services/logger.ts

const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  NONE: 4, // To disable all logs
} as const;

type LogLevelKeys = keyof typeof LOG_LEVELS;
type LogLevelValues = (typeof LOG_LEVELS)[LogLevelKeys];

// Determine current log level.
// Default to INFO for production, DEBUG for development.
// You could make this configurable via environment variables if needed.
const currentLogLevel: LogLevelValues = import.meta.env.DEV
  ? LOG_LEVELS.DEBUG
  : LOG_LEVELS.INFO;

const formatMessage = (level: LogLevelKeys, ...args: unknown[]): unknown[] => {
  // Optional: Add timestamps or other context here
  // const timestamp = new Date().toISOString();
  // return [`[${timestamp}] [${level}]`, ...args];
  return [`[WEBUI-${level}]`, ...args];
};

const logger = {
  debug: (...args: unknown[]): void => {
    if (currentLogLevel <= LOG_LEVELS.DEBUG) {
      // eslint-disable-next-line no-console
      console.debug(...formatMessage('DEBUG', ...args));
    }
  },
  info: (...args: unknown[]): void => {
    if (currentLogLevel <= LOG_LEVELS.INFO) {
      // eslint-disable-next-line no-console
      console.info(...formatMessage('INFO', ...args));
    }
  },
  warn: (...args: unknown[]): void => {
    if (currentLogLevel <= LOG_LEVELS.WARN) {
      // eslint-disable-next-line no-console
      console.warn(...formatMessage('WARN', ...args));
    }
  },
  error: (...args: unknown[]): void => {
    if (currentLogLevel <= LOG_LEVELS.ERROR) {
      // eslint-disable-next-line no-console
      console.error(...formatMessage('ERROR', ...args));
      // TODO: Integrate with a remote error tracking service like Sentry if needed
      // e.g., Sentry.captureException(args[0] instanceof Error ? args[0] : new Error(String(args[0])), { extra: args.slice(1) });
    }
  },
};

export default logger;
